import React from 'react';
import Layout from '../components/layout';
import { TbArrowRight } from 'react-icons/tb';
import { Tab } from '@headlessui/react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import 'swiper/css';
import 'swiper/css/pagination';

const Solutions = () => {
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    let [categories] = React.useState({
        'Lead Generation': [
            {
                id: 1,
                title: 'Reach potential leads',
                body: 'Our innovative approach amplifies communication, reshaping how brands convey messages and engage with their audiences. ',
                image: <StaticImage
                    src="../images/lead-generation.png"
                    alt='solutions'
                    placeholder="blurred"
                    quality="100"
                    className=''
                />
            },
        ],
        'App Installations': [
            {
                id: 2,
                title: "Increase your app's presence",
                body: "Grow app users with measurable app installation projects.   Reach your target audience precisely where they're active, guiding them to seamlessly download and engage with your app.",
                image: <StaticImage
                    src="../images/app-installation.png"
                    alt='solutions'
                    placeholder="blurred"
                    quality="100"
                    className=''
                />
            },
        ],
        'Website Traffic': [
            {
                id: 1,
                title: "Boost online visibility",
                body: "Attract a steady stream of visitors to your website, expanding your reach and engagement. Whether you're aiming to showcase your products, share valuable content, or promote your services, captivate your audience as they explore your offerings and discover what your brand has to offer.",
                image: <StaticImage
                    src="../images/website-traffic.png"
                    alt='solutions'
                    placeholder="blurred"
                    quality="100"
                    className=''
                />
            },
        ],
        'Sign Ups': [
            {
                id: 1,
                title: "Streamline user engagement",
                body: "Expand your customer network through precise sign-up campaigns, leading them to effortlessly engage with your brand, prompting them to take action by enrolling in your services.",
                image: <StaticImage
                    src="../images/sign-up.png"
                    alt='solutions'
                    placeholder="blurred"
                    quality="100"
                    className=''
                />
            },
        ],
        'Registration': [
            {
                id: 1,
                title: "Get your audience to take action",
                body: "From event registration to user accounts, engage your audience while efficiently gathering insights. Make every interaction count with user-friendly registration processes that enhance your lead-generation efforts.",
                image: <StaticImage
                    src="../images/registration.png"
                    alt='solutions'
                    placeholder="blurred"
                    quality="100"
                    className=''
                />
            },
        ],
    })

    return (
        <Layout pageTitle='Products - Dochase Adx'>
            <div className='lg:max-w-[1440px] mx-auto pt-20 lg:pt-28'>
                <section className='relative inline-block w-full'>
                    <StaticImage
                        src="../images/solutions.png"
                        alt='solutions'
                        placeholder="blurred"
                        quality="100"
                        className='block max-w-full mx-auto'
                    />
                    <div className='absolute top-[55%] lg:top-[45%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full lg:w-3/4'>
                        <p className='text-white font-bold text-2xl lg:text-8xl text-center'>Our Solutions</p>
                        <p className='text-white font-medium text-xs lg:text-[28px] lg:leading-10 text-center mt-6 lg:mt-11 mx-8 lg:mx-0'>We understand that every business is unique, and so, no matter what your goal is, whether It is increasing sales, generating leads or retaining customers, our solutions have been tailored specifically to meet your needs. </p>
                        <div className='w-full flex justify-center'>
                            <Link to='/#form'>
                                <button className='bg-brand-red text-white py-1 lg:py-3 px-5 lg:px-11 rounded-md font-bold mt-4 lg:mt-14 text-xs lg:text-sm'>Get Started</button>
                            </Link>
                        </div>
                    </div>
                </section>

                <section className='lg:max-w-[1440px] mx-auto pt-16 lg:pt-36' id='dsp'>
                    <div className='lg:mx-[16.4%]'>
                        <p className='text-[#454444] text-3xl lg:text-5xl font-bold text-center'>Programmatic Advertising</p>
                    </div>

                    <div className='lg:grid lg:grid-cols-2 mt-12 lg:mt-24 mx-[5%] lg:mx-[10%]'>
                        <div className='lg:pr-[12%]'>
                            <p className='text-2xl lg:text-4xl font-bold'>DSP</p>
                            <p className='mt-3 lg:mt-7 text-base lg:text-xl'>Manage your media buying, rich media and programmatics deals from Dochase DSP. With our DSP, you can reach your target audience on top local publishers, websites and +2million sites and apps. Deploy adverts  for banner, native, push, rich media and more. With access to leading supplies, buy inventory on websites, apps and mobile web, and in-stream video through one interface.</p>
                            <Link to='/#form'>
                                <button className='text-brand-red font-bold text-xs lg:text-sm flex mt-4 lg:mt-9'>Get Started <TbArrowRight className='w-4 h-4 my-auto ml-2' /></button>
                            </Link>
                        </div>
                        <StaticImage
                            src="../images/dsp.png"
                            alt='solutions'
                            placeholder="blurred"
                            quality="100"
                            className='mt-4 lg:mt-0 lg:w-full'
                        />
                    </div>
                </section>

                <section className='pt-24 lg:pt-48 lg:max-w-[1440px] mx-auto' id='customer-acquisition'>
                    <div className='lg:mx-[10%]'>
                        <p className='text-[#454444] text-3xl lg:text-5xl font-bold text-center'>Customer Acquisition</p>
                        <p className='text-[#454444] text-base lg:text-xl mt-3 lg:mt-6 mx-[10%] lg:mx-[20%] text-center'>Our innovative approach amplifies communication, reshaping how brands convey messages and engage with their audiences. </p>

                        <div className='hidden lg:block pt-24 w-full' id='lead-generation'>
                            <Tab.Group>
                                <div className='flex space-x-20'>
                                    <Tab.List className="h-80 rounded-xl p-1 grid gap-5">
                                        {Object.keys(categories).map((category) => (
                                            <Tab
                                                key={category}
                                                className={({ selected }) =>
                                                    classNames(
                                                        'w-48 h-11 rounded-3xl border border-brand-red text-xl font-bold text-brand-red',
                                                        selected
                                                            ? 'bg-brand-red text-white'
                                                            : 'hover:bg-brand-red hover:text-white'
                                                    )
                                                }
                                            >
                                                {category}
                                            </Tab>
                                        ))}
                                    </Tab.List>
                                    <Tab.Panels className="mt-2">
                                        {Object.values(categories).map((posts, idx) => (
                                            <Tab.Panel
                                                key={idx}
                                                className={classNames(
                                                    'bg-white'
                                                )}
                                            >
                                                {posts.map((post) => (
                                                    <div key={post.id} className='flex space-x-16'>
                                                        <div className='w-1/2'>
                                                            <p className='text-4xl font-bold'>{post.title}</p>
                                                            <p className='mt-7 text-xl'>{post.body}</p>
                                                            <Link to='/#form'>
                                                                <button className='text-brand-red font-bold text-xs lg:text-sm flex mt-4 lg:mt-9'>Get Started <TbArrowRight className='w-4 h-4 my-auto ml-2' /></button>
                                                            </Link>
                                                        </div>
                                                        <div className='w-1/2 justify-end object-cover' >
                                                            {post.image}
                                                        </div>
                                                    </div>
                                                ))}
                                            </Tab.Panel>
                                        ))}
                                    </Tab.Panels>
                                </div>
                            </Tab.Group>
                        </div>

                        <div className='lg:hidden mt-12 w-full'>
                            <Tab.Group>
                                <div className=''>
                                    <Tab.List className="rounded-xl p-1 flex justify-between">
                                        <Swiper
                                            slidesPerView={2.5}

                                            className='mySwiper'
                                        >
                                            {Object.keys(categories).map((category) => (
                                                <SwiperSlide>
                                                    <Tab
                                                        key={category}
                                                        className={({ selected }) =>
                                                            classNames(
                                                                'py-3 w-32 rounded-xl border border-brand-red text-xs font-bold text-brand-red',
                                                                selected
                                                                    ? 'bg-brand-red text-white'
                                                                    : 'hover:bg-brand-red hover:text-white'
                                                            )
                                                        }
                                                    >
                                                        {category}
                                                    </Tab>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </Tab.List>
                                    <Tab.Panels className="mt-8 mx-[5%]">
                                        {Object.values(categories).map((posts, idx) => (
                                            <Tab.Panel
                                                key={idx}
                                                className={classNames(
                                                    'bg-white'
                                                )}
                                            >
                                                {posts.map((post) => (
                                                    <div key={post.id} className=''>
                                                        <div className=''>
                                                            <p className='text-2xl font-bold'>{post.title}</p>
                                                            <p className='mt-3 text-base'>{post.body}</p>
                                                            <button className='text-brand-red font-bold text-xs lg:text-sm flex mt-4 lg:mt-9'>Get Started <TbArrowRight className='w-4 h-4 my-auto ml-2' /></button>
                                                        </div>
                                                        <img src={post.image} className=' mt-4 w-3/4 mx-auto' loading='lazy' alt='post image'/>
                                                    </div>
                                                ))}
                                            </Tab.Panel>
                                        ))}
                                    </Tab.Panels>
                                </div>
                            </Tab.Group>
                        </div>
                    </div>
                </section>

                <section className='lg:max-w-[1440px] mx-auto pt-24 lg:pt-48' id='customer-engagement'>

                    <div className='lg:flex lg:space-x-20 mt-12 lg:mt-24 mx-[5%] lg:mx-[20%]'>
                        <div className='lg:w-1/2'>
                            <p className='text-2xl lg:text-4xl font-bold'>Customer Engagement</p>
                            <p className='mt-3 lg:mt-7 text-base lg:text-xl'>Captivate your customers at every touchpoint, drive brand affinity and establish a strong rapport with your audience through Rich Media, SMS, click-to-Whatsapp, email, Click-to-USSD, Video ads and more.</p>
                            <Link to='/#form'>
                                <button className='text-brand-red font-bold text-xs lg:text-sm flex mt-4 lg:mt-9'>Get Started <TbArrowRight className='w-4 h-4 my-auto ml-2' /></button>
                            </Link>
                        </div>
                        <StaticImage
                            src="../images/customer-engagement.png"
                            alt='solutions'
                            placeholder="blurred"
                            quality="100"
                            className='lg:justify-end mt-4 lg:mt-0 lg:w-80'
                        />
                    </div>
                </section>

                <section className='lg:max-w-[1440px] mx-auto py-24 lg:py-48' id='retargeting'>

                    <div className='lg:flex lg:space-x-20 mt-12 lg:mt-24 mx-[5%] lg:mx-[20%]'>
                        <div className='lg:w-1/2'>
                            <p className='text-2xl lg:text-4xl font-bold'>Retargeting</p>
                            <p className='mt-3 lg:mt-7 text-base lg:text-xl'>With our retargeting pixels integrated into your website, everyone who clicked on your ad without performing any action, started a process but did not complete the action would be retargeted with Ads to complete actions. (Signup or make a deposit).</p>
                            <Link to='/#form'>
                                <button className='text-brand-red font-bold text-xs lg:text-sm flex mt-4 lg:mt-9'>Get Started <TbArrowRight className='w-4 h-4 my-auto ml-2' /></button>
                            </Link>
                        </div>
                        <StaticImage
                            src="../images/retargeting.png"
                            alt='solutions'
                            placeholder="blurred"
                            quality="100"
                            className='lg:justify-end mt-4 lg:mt-0 lg:w-80'
                        />
                    </div>
                </section>
            </div>
        </Layout>
    )
}

export default Solutions